import { Loader2 } from "lucide-react";
import * as React from "react";
import { cn } from "@client/lib/cn";

export interface SpinnerProps extends React.HTMLAttributes<HTMLDivElement> {
  size?: "sm" | "md" | "lg";
}

const sizeClasses = {
  sm: "h-4 w-4",
  md: "h-6 w-6",
  lg: "h-10 w-10",
};

export const Spinner = ({ size = "md", className, ...props }: SpinnerProps) => (
  <div role="status" className={cn("inline-flex items-center justify-center", className)} {...props}>
    <Loader2 className={cn("animate-spin text-primary", sizeClasses[size])} />
    <span className="sr-only">Načítání…</span>
  </div>
);
